import React from "react";
import { TreeIcon } from "./TtgFeature";
import { faMobile as farMobile } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { chartTypeKeyMap } from "../utils/constants/chartConstants";
import { faBolt } from "@fortawesome/pro-solid-svg-icons";

export default function PageDisplayName({ page, displayName }) {
  if (!page) {
    return null;
  }
  return (
    <>
      {displayName ?? page.displayName}
      {page.mobile && (
        <>
          {" "}
          <FontAwesomeIcon
            icon={farMobile}
            title="This page be visible only on mobile"
          />
        </>
      )}
      {page.blocks?.[0]?.visualizations[0]?.settings?.type ===
      chartTypeKeyMap.ActiveTable ? (
        <>
          {" "}
          <FontAwesomeIcon icon={faBolt} fixedWidth title="Active Table" />
        </>
      ) : null}

      {page.ttg && (
        <>
          {" "}
          <TreeIcon title="This page is visible to TTG users only" />
        </>
      )}
    </>
  );
}
